import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Params, RouterModule } from '@angular/router';

import { SmartLinkComponent } from '@valk-nx/core/lib/components/smart-link/smart-link.component';
import { LinkTarget } from '@valk-nx/core/lib/core';
import { HeadingDirective } from '@valk-nx/core/lib/directives/heading/heading.directive';
import { HeadingType } from '@valk-nx/core/lib/directives/heading/heading.type';

import { LinkType } from '../../persuade-card.interface';

@Component({
	selector: 'vp-persuade-card-header',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [HeadingDirective, SmartLinkComponent, RouterModule],
	templateUrl: 'persuade-card-header.component.html',
})
export class PersuadeCardHeaderComponent {
	readonly title = input.required<string>();
	readonly overline = input<string | undefined>(undefined);
	readonly headingType = input<HeadingType>('h3');
	readonly cardUrl = input<string | undefined>(undefined);
	readonly cardLinkType = input<LinkType>('story');
	readonly cardQueryParams = input<Params>();
	readonly cardTarget = input<LinkTarget | undefined>(undefined);
}
